<template>
  <section class="content-wrapper">
    <section class="content">
      <div class="row">
        <div class="col-md-8 col-sm-12 offset-md-2">


          <div class="m-portlet">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
						      <span class="m-portlet__head-icon m--hide">
						        <i class="la la-gear"></i>
						      </span>
                  <h3 class="m-portlet__head-text">
                    Resources
                  </h3>
                </div>
              </div>
              <div class="m-portlet__head-tools">
                <div class="col text-right align-self-center pr-0">
                <span class="btn btn-brand m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill btn-sm" @click="$refs.userForm.create()">
                  <i class="fa fa-plus"></i> Add new resource
                </span>
                </div>
              </div>
            </div>
            <!--begin::Form-->
            <div class="m-portlet__body">

              <div class="box-body mt-3">
                <div class="row" v-if="!users">
                  <loader></loader>
                </div>

                <div class="row users-row" v-for="user, index in users" v-else>
                  <div class="col">
                    <div class="user">
                      <div class="photo">
                        <img :src="user.photo" alt="">
                      </div>
                      <div class="name">
                        <span class="main">{{ user.name }}</span>
                        <span class="tagline">
                          {{ user.tagline }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col justify-content-end align-self-center">
                    <div class="actions">
                      <div href="#" class="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" @click="$refs.userForm.edit(user)" title="Edit">
                        <i class="la la-pencil"></i>
                      </div>
                      <div href="#" class="m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" v-if="user.id != 1" @click="tryToDestroy(user.id, index)" title="Delete">
                        <i class="la la-times"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </section>

    <user-form ref="userForm" @userCreated="appendUser" @userUpdated="updateUser" @userPhotoUpdated="updateUserPhoto"></user-form>

  </section>
</template>


<script>
  import userForm from './UserForm'

  export default {
    components: {
      'user-form': userForm,
    },
    data() {
      return {
        users: false,
        showCreate: false,
      }
    },
    created() {
      this.axios.get('/users').then(response => {
        this.users = response.data.data
      })
    },
    methods: {
      tryToDestroy(user_id, user_index) {
        this.$swal({
          title: 'Are you sure?',
          text: 'You won\'t be able to revert this!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete',
          confirmButtonColor: '#dd4b39',
          focusCancel: true,
          reverseButtons: true
        }).then(result => {
          if (result.value) {
            this.destroy(user_id, user_index)
          }
        })
      },
      destroy(user_id, user_index) {
        this.axios.delete('/users/' + user_id).then(result => {
          if (result.status === 204) {
            this.users.splice(user_index, 1);
          }
        })
      },
      appendUser(user) {
        this.users.push(user)
      },
      updateUser(user) {
        //swap this to axios.get to reload all users?
        //now this gets a user, then finds the same user in users array, and updates it with new value
        this.users[this.userIndex(user.id)] = user
        this.$forceUpdate()
      },
      updateUserPhoto(data) {
        this.users[this.userIndex(data.user_id)].photo = data.src;
        this.$forceUpdate()
      },
      userIndex(id) {
        for (let key in this.users) {
          if (id === this.users[key].id) {
            return key
          }
        }
      }
    }
  }
</script>


<style scoped lang="scss">
  .users-row {
    &:nth-child(odd) {
      background: #f6f6fb;
    }
    .user {
      display: flex;
      padding: 5px;
      .photo {
        border-radius: 5rem;
        overflow: hidden;
        margin-right: 10px;
        width: 5rem;
        height: 5rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .name {
        font-size: 1.5rem;
        display: flex;
        flex-flow: column;
        justify-content: center;

        .main {

        }
        .tagline {
          font-size: 1rem;
        }

      }

    }
    .actions {
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/users/Index.vue